import { Button, DialogContentText } from "@carrotfertility/carotene-core"
import { InfoDialog } from "@carrotfertility/carotene-core-x"
import { MessageReceivedModalBaseProps } from "#/components/talk-to-carrot/send-message/SendMessage"
import React from "react"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"
import { FormattedMessage, useIntl } from "react-intl"

type AccountDeletedModalProps = MessageReceivedModalBaseProps

export function AccountDeletedModal(props: AccountDeletedModalProps): JSX.Element {
  const intl = useIntl()
  return (
    <EmployeeOnlyModalContainer onClose={props.onExit}>
      <InfoDialog
        title={intl.formatMessage({ defaultMessage: "Request sent" })}
        open
        primaryAction={
          <Button data-testid="account-deletion-sign-out" onClick={props.onExit}>
            <FormattedMessage defaultMessage="Sign out" />
          </Button>
        }
      >
        <DialogContentText>
          <FormattedMessage defaultMessage="We'll provide an update within 30 business days." />
        </DialogContentText>
      </InfoDialog>
    </EmployeeOnlyModalContainer>
  )
}
